/**
 * Global paid-status resolver.
 *
 * A single source of truth for "is this user a paying customer?" that survives
 * the beta → public-launch transition without any code rewrites.
 *
 *   BETA_IS_ACTIVE === true  (current beta phase)  → resolve via `is_paid_beta`
 *   BETA_IS_ACTIVE === false (future public launch) → resolve via `is_paid`
 *
 * Toggle `BETA_IS_ACTIVE` in backend/.env (surfaced to the frontend through
 * GET /api/config as `beta_is_active`) and the entire app switches fields.
 *
 * @param {object|null} user          The hydrated /api/auth/me user object.
 * @param {boolean}     betaIsActive  cfg.beta_is_active (defaults to true).
 * @returns {boolean}
 */
export function resolvePaidStatus(user, betaIsActive = true) {
    if (!user) return false;
    return betaIsActive ? Boolean(user.is_paid_beta) : Boolean(user.is_paid);
}
